const PEOPLE = [
  // [cx, cy, generation]
  [200, 62, 0],
  [120, 150, 1],
  [280, 150, 1],
  [70, 238, 2],
  [160, 238, 2],
  [240, 238, 2],
  [330, 238, 2],
];

const LINKS = [
  [0, 1],
  [0, 2],
  [1, 3],
  [1, 4],
  [2, 5],
  [2, 6],
];

const RADIUS = [30, 25, 20];

export default function FamilyTreeArt() {
  return (
    <svg className="tree-art" viewBox="0 0 400 300" role="img" aria-label="Illustration of a family tree with three generations">
      <defs>
        <radialGradient id="tree-glow" cx="50%" cy="40%" r="60%">
          <stop offset="0%" stopColor="var(--accent)" stopOpacity="0.28" />
          <stop offset="100%" stopColor="var(--accent)" stopOpacity="0" />
        </radialGradient>
      </defs>
      <circle cx="200" cy="140" r="160" fill="url(#tree-glow)" />
      {LINKS.map(([a, b]) => {
        const [x1, y1] = PEOPLE[a];
        const [x2, y2] = PEOPLE[b];
        const midY = (y1 + y2) / 2;
        return (
          <path
            key={`${a}-${b}`}
            className="tree-art__branch"
            d={`M${x1} ${y1} C${x1} ${midY}, ${x2} ${midY}, ${x2} ${y2}`}
          />
        );
      })}
      {PEOPLE.map(([cx, cy, gen], i) => (
        <g key={i} className={`tree-art__node tree-art__node--g${gen}`} style={{ animationDelay: `${i * 0.12}s` }}>
          <circle cx={cx} cy={cy} r={RADIUS[gen]} />
          <circle cx={cx} cy={cy - RADIUS[gen] * 0.22} r={RADIUS[gen] * 0.3} className="tree-art__head" />
          <path
            className="tree-art__head"
            d={`M${cx - RADIUS[gen] * 0.5} ${cy + RADIUS[gen] * 0.55} a${RADIUS[gen] * 0.5} ${RADIUS[gen] * 0.42} 0 0 1 ${RADIUS[gen]} 0`}
          />
        </g>
      ))}
      <path className="tree-art__leaf" d="M352 70c-18 0-30 12-30 30 18 0 30-12 30-30Z" />
      <path className="tree-art__leaf" d="M46 120c14 0 24 10 24 24-14 0-24-10-24-24Z" />
    </svg>
  );
}
